import React from "react"
import { LazyMount } from "components/MountIfVisible"
import { event } from "utils/gtag"

function InstallAppollowVideo() {
  return (
    <LazyMount stayRendered visibleOffset={150}>
      <video
        src="/files/install-appollow.mov"
        width="100%"
        className="rounded-m mt-4"
        controls
        style={{ maxHeight: 450 }}
        onEnded={() => {
          event({
            action: "article_demo_video_finish",
            category: "Install PWA Sheet",
            label: "install PWA sheet demo video watched fully",
          })
        }}
        onLoadStart={() =>
          event({
            action: "article_demo_video_loading",
            category: "Install PWA Sheet",
            label: "install PWA sheet demo video watched fully",
          })
        }
        onCanPlay={() =>
          event({
            action: "article_demo_video_playing",
            category: "Install PWA Sheet",
            label: "install PWA sheet demo video watched fully",
          })
        }
      ></video>
    </LazyMount>
  )
}

export default InstallAppollowVideo
